"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "albugnano": {
    "e86acbb6": [{
      "hkey": "bccc1a7a",
      "slug": "albugnano",
      "name": "Albugnano",
      "primary": true,
      "skipSearch": false
    }],
    "sant-emiliano": [{
      "hkey": "bccc1a7a",
      "slug": "albugnano",
      "name": "Albugnano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "36cdab72": [{
      "hkey": "bccc1a7a",
      "slug": "albugnano",
      "name": "Albugnano",
      "primary": true,
      "skipSearch": false
    }],
    "santo-stefano": [{
      "hkey": "bccc1a7a",
      "slug": "albugnano",
      "name": "Albugnano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "89f7d14e": [{
      "hkey": "bccc1a7a",
      "slug": "albugnano",
      "name": "Albugnano",
      "primary": true,
      "skipSearch": false
    }],
    "vezzolano": [{
      "hkey": "bccc1a7a",
      "slug": "albugnano",
      "name": "Albugnano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;